// extracted by mini-css-extract-plugin
export var chevron = "_38-d";
export var disabled = "_38-b";
export var error = "_38-c";
export var hideBorder = "_38-1";
export var icon = "_38-e";
export var input = "_38-0";
export var open = "_38-9";
export var placeholder = "_38-a";
export var regular = "_38-5";
export var singleRowInput = "_38-2";
export var singleSelectInput = "_38-3 _38-0";
export var small = "_38-4";
export var spinnerContainer = "_38-g";
export var tag = "_38-7";
export var tagsContainer = "_38-8";
export var tagsInput = "_38-6 _38-0";
export var xSmall = "_38-f";